import './recruitment.scss';

// ここにページの js を記述します
// Find the button with the question
const question = document.getElementsByClassName('question'),
  answer = document.getElementsByClassName('answer');

for (let i = 0; i < question.length; i++) {
  question[i].addEventListener('click', () => {
    answer[i].style.display =
      answer[i].style.display == 'flex' ? 'none' : 'flex';
    answer[i].classList.toggle('is-active');
    question[i].classList.toggle('is-active');
  });
}
